const LOCAL_AEM_ORIGIN = 'http://localhost:4502';
const LOCAL_AEM_PREVIEW_EXPORTER = `${LOCAL_AEM_ORIGIN}/bin/vaahome/AEMPreviewDataExporter`;

export const LOCAL_AEM_MAIN_BASEPATH = `${LOCAL_AEM_ORIGIN}/`;
export const LOCAL_AEM_PREVIEW_BASEPATH = `${LOCAL_AEM_PREVIEW_EXPORTER}?brandPath=`;
export const LOCAL_AEM_PREVIEW_ASSET_BASEPATH = `${LOCAL_AEM_PREVIEW_EXPORTER}?assetPath=`;
